import { Pipe, PipeTransform } from '@angular/core';

import { ShipmentRouting } from '../../../pages/overview/models/shipment';

@Pipe({
  name: 'shouldShowBookedRouting',
  standalone: true
})
export class ShouldShowBookedRoutingPipe implements PipeTransform {
  transform(routing: ShipmentRouting | null): boolean {
    return !!routing && (!!routing.cargoReady || !!routing.reqEtd || !!routing.reqEta);
  }
}
